import React from "react";
// CSS footer đã được hợp nhất vào App.css

// TypeScript interface
interface FooterProps {
  fluid?: boolean;
}

const Footer: React.FC<FooterProps> = ({ fluid = false }) => {
  return (
    <footer className="footer">
      <div className={`container${fluid ? '-fluid' : ''}`}>
        <div className="footer-content">
          <div className="row">
            <div className="col-md-4">
              <div className="footer-brand">
                <h3 className="footer-title">Hoài Thương Fruits</h3>
                <p className="footer-description">
                  Chuyên cung cấp các loại trái cây nhập khẩu và nội địa chất lượng cao.
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <h5 className="footer-heading">Liên kết nhanh</h5>
              <ul className="footer-links">
                <li><a href="/">Trang chủ</a></li>
                <li><a href="/products">Sản phẩm</a></li>
                <li><a href="/about">Giới thiệu</a></li>
                <li><a href="/contact">Liên hệ</a></li>
              </ul>
            </div>
            <div className="col-md-3">
              <h5 className="footer-heading">Liên hệ</h5>
              <ul className="footer-contact">
                <li><i className="fa fa-map-marker"></i> 115 Trần Phú, TP Buôn Ma Thuột</li>
                <li><i className="fa fa-phone"></i> 039 812 6899</li>
                <li><i className="fa fa-envelope"></i> hoaithuongfruits@gmail.com</li>
              </ul>
            </div>
            <div className="col-md-2">
              <h5 className="footer-heading">Theo dõi</h5>
              <div className="footer-social">
                <a href="#" className="social-icon"><i className="fa fa-facebook"></i></a>
                <a href="#" className="social-icon"><i className="fa fa-instagram"></i></a>
                <a href="#" className="social-icon"><i className="fa fa-youtube"></i></a>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="footer-bottom">
          <p className="copyright">
            &copy; {new Date().getFullYear()} Hoài Thương Fruits. Tất cả quyền được bảo lưu.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 